import { MTableBodyRow } from "@material-table/core";
import className from "classnames";
import { GOVGR_TABLE__ROW } from "../../../../conf/styles/GovGrTable";
// const useStyles = makeStyles({
//   deleteRow: {
//     "& td": {
//       textAlign: "center",
//     },
//   },
// });

const GovGrTableBodyRow = (props) => {
  // const classes = useStyles();
  let ComponentWrapperClass = className(GOVGR_TABLE__ROW);
  return <MTableBodyRow className={ComponentWrapperClass} {...props} />;
};

export default GovGrTableBodyRow;
